import { render, staticRenderFns } from "./NumberFilter.vue?vue&type=template&id=656519c2&scoped=true&"
import script from "./NumberFilter.vue?vue&type=script&lang=ts&"
export * from "./NumberFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656519c2",
  null
  
)

export default component.exports